import {
  AuthenticationContext,
  adalFetch,
  withAdalLogin,
  AdalConfig,
} from 'react-adal';
import { AdalClientId, AdalTenantId, AdalFhirId } from '../constants';

export const adalConfig: AdalConfig = {
  tenant: `${AdalTenantId}`,
  clientId: `${AdalClientId}`,
  endpoints: {
    fhir: `${AdalFhirId}`,
  },
  redirectUri: `${window.location.origin}/organization`,
  cacheLocation: 'localStorage',
};

export const authContext = new AuthenticationContext(adalConfig);

export const adalApiFetch = (fetch: any, url: string, options: any) => {
  if (!adalConfig.endpoints) throw new Error('Endpoints is missing');

  return adalFetch(authContext, adalConfig.endpoints.fhir, fetch, url, options);
};

if (!adalConfig.endpoints) throw new Error('Endpoints is missing');

export const withAdalLoginApi = withAdalLogin(
  authContext,
  adalConfig.endpoints.fhir,
);
